import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import BASE_URL from '../config';
import './styles/course.css';

const CourseDetail = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);

  useEffect(() => {
    fetchCourseDetails();
  }, []);

  const fetchCourseDetails = async () => {
    try {
      const result = await axios.get(`${BASE_URL}/api/coursesd/${id}`);
      setCourse(result.data);
    } catch (error) {
      console.error('Error fetching course details:', error);
    }
  };

  const renderDetails = (details) => {
    if (!details) return null;

    const lines = details.split('\n');
    const formattedContent = [];
    let isHeading = true;

    lines.forEach((line, index) => {
      if (line.trim() === '') {
        isHeading = true; // Reset after a blank line
      } else if (isHeading) {
        formattedContent.push(
          <h2 key={`heading-${index}`}>{line}</h2>
        );
        isHeading = false;
      } else {
        formattedContent.push(
          <p key={`paragraph-${index}`}>{line}</p>
        );
      }
    });

    return formattedContent;
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {course ? (
        <div className="course-container">
          {/* Image Section */}
          <div className="image-container">
            <img
              src={`${BASE_URL}${course.img_url}`}
              alt={course.title}
            />
          </div>

          {/* Details Section */}
          <div className="course-details">
            <h1 className="course-title">{course.title}</h1>
            <div>{renderDetails(course.details)}</div>
          </div>
        </div>
      ) : (
        <p>Loading course details...</p>
      )}
    </div>
  );
};

export default CourseDetail;
